module.exports = __webpack_public_path__ + "static/media/administration final icon.ecb6ea61.svg";